<template>
  <div style="width: 100%; height: 100%">
    <el-row>
      <el-col :span="6" :offset="20">
        <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="openPreviewDialog"
          v-show="this.printStatus === 1 && companyID !== 100" v-if="this.USE_PRINT_TEMPLATE == 0">打印预览</el-button>
        <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="payablePrint"
          v-show="this.printStatus === 1 && companyID !== 100" v-if="this.USE_PRINT_TEMPLATE == 0">抬头打印</el-button>
        <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="previewPrint"
          v-if="this.USE_PRINT_TEMPLATE == 1">打印预览</el-button>
      </el-col>
      <el-col v-show="this.printStatus === 1">
        <el-button size="small" type="danger" @click="haveCheck">导出</el-button>
        <span style="color: red">注：点击“导出”按钮后，订单将从“待送”状态变为“待确认”状态，请谨慎使用</span>
      </el-col>
    </el-row>
    <el-row :data="data">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li>
            客&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;户：{{ data[0].GYS_NAME }}
          </li>
          <li>
            供&nbsp;&nbsp;&nbsp;&nbsp;应&nbsp;&nbsp;&nbsp;&nbsp;商：{{ data[0].SUPPLIER_NAME }}
          </li>
          <li>地址：{{ data[0].PROJECT_ADDRESS }}</li>
          <li>送&nbsp;货&nbsp;日&nbsp;期&nbsp;：{{ data[0].SEND_DAY }}</li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li>联系电话：{{ data[0].GYS_TELPHONE }}</li>
          <li>
            制&nbsp;&nbsp;&nbsp;&nbsp;单&nbsp;&nbsp;&nbsp;&nbsp;人：{{ managername }}
          </li>
          <li>订&nbsp;单&nbsp;编&nbsp;号&nbsp;：{{ data[0].ORDER_CODE }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%" :span-method="objectSpanMethod" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" label="序号" width="45" min-width="30" :index="indexMethod"></el-table-column>
          <el-table-column label="名称" prop="SHORT_NAME" min-width="100"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="100"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="单价（元）" prop="REAL_PRICE"></el-table-column>
          <el-table-column label="订购数量" prop="PRODUCT_COUNT"></el-table-column>
          <el-table-column label="送货数量" prop="NEED_COUNT"></el-table-column>
          <el-table-column label="总价（元）" prop="REAL_FEE"></el-table-column>
          <el-table-column label="备注" prop="PRODUCT_COMMENT"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="openEdit(scope.row)" v-show="fun_dic[100020202]">修改</el-button>
              <el-button type="text" @click="openAllEdit(scope.row)" v-show="fun_dic[100020201]">修改全部</el-button>
            </template>
          </el-table-column>
          <el-table-column label="公司名称" prop="TC_NAME"></el-table-column>
          <el-table-column label="项目点-档口" prop="DK_NAME" width="100"></el-table-column>
          <el-table-column label="客户订购数量" prop="CUSTOMER_PRODUCT_COUNT"></el-table-column>
          <el-table-column label="供应商送货数量" prop="CUSTOMER_NEED_COUNT"></el-table-column>
          <el-table-column label="客户备注" prop="CUSTOMER_PRODUCT_COMMENT"></el-table-column>
          <el-table-column label="分拣操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="openeditSortingCountDialog(scope.row)">修改</el-button><br>
              <el-button type="text" @click="toPrintTable(scope.row)">
                {{ scope.row.COUNT_OF_PRINT == 0 ? '分拣小票打印' : '分拣小票补打' }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row :data="data">
      <el-col>
        <p>收货时间：</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <p>送货员：</p>
      </el-col>
      <el-col :span="6">
        <p>项目经理：</p>
      </el-col>
      <el-col :span="6">
        <p>厨师长：</p>
      </el-col>
      <el-col :span="6">
        <p>验收人员：</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button @click="batchEdit" style="margin-top: 20px; " type="primary" size="small">
          批量修改送货数量
        </el-button>
        <el-button @click="updateSendCont" style="margin-top: 20px; float: right" type="primary" size="small">
          更新送货数量
        </el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col>
        <el-steps :active="this.statusFlag" finish-status="success" v-show="this.statusFlag !== 0" :space="200">
          <el-step :title="item.T" :description="item.D" v-for="item in checkData" :key="item.value"></el-step>
        </el-steps>
        <h4 v-show="this.statusFlag === 0" style="color: #e6a23c">
          暂无流程记录信息
        </h4>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="修改产品" center :visible.sync="editFormVisible" width="600px" :close-on-click-modal="false">
          <el-form :model="editForm" ref="editForm">
            <el-form-item label="产品名称：" :label-width="formLabelWidth">
              <span>{{ name }}</span>
            </el-form-item>
            <el-form-item label="送货数量：" :label-width="formLabelWidth">
              <el-input v-model="editForm.NEED_COUNT"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button @click="submitEdit" :loading="loading">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="修改全部信息" center :visible.sync="editAllFormVisible" width="600px">
          <el-form :model="editAllForm" ref="editAllForm">
            <el-form-item label="产品名称：" :label-width="formLabelWidth">
              <span>{{ Editname }}</span>
            </el-form-item>
            <el-form-item label="采购价：" :label-width="formLabelWidth">
              <el-input v-model="editAllForm.BUY_PRICE" @change="countPrice"></el-input>
            </el-form-item>
            <el-form-item label="报损后单价：" :label-width="formLabelWidth">
              <span> {{ editAllForm.WPRICE }}</span>
            </el-form-item>
            <el-form-item label="销售价：" :label-width="formLabelWidth">
              <el-input v-model="editAllForm.REAL_PRICE"></el-input>
            </el-form-item>
            <el-form-item label="订购数量：" :label-width="formLabelWidth">
              <el-input v-model="editAllForm.PRODUCT_COUNT"></el-input>
            </el-form-item>
            <el-form-item label="备注：" :label-width="formLabelWidth">
              <el-input v-model="editAllForm.PRODUCT_COMMENT"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="closeAll">取 消</el-button>
            <el-button @click="submitEditAll" :loading="loading">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="" center :visible.sync="previewVisible" width="450px">
          <label style="display: inline-block; margin-left: 20px; margin-top: 20px">是否打印价格:</label>
          <el-radio style="margin: 0px 80px 0 50px" v-model="carryPrice" label="1">是</el-radio>
          <el-radio v-model="carryPrice" label="0">否</el-radio>
          <label style="display: inline-block; margin-left: 20px; margin-top: 40px">是否带实收:</label>
          <el-radio-group v-model="actualReceiptsRadio" style="margin-top: 20px">
            <el-radio :label="1" style="margin-left: 50px">带实收</el-radio>
            <el-radio :label="0" style="margin-left: 27px">不带实收</el-radio>
          </el-radio-group>

          <el-form ref="nameForm" :model="nameForm" :label-width="formLabelWidth" style="margin: 50px 0 0 0">
            <el-form-item label="公司名称：">
              <el-input id="companyName" v-model="nameForm.companyName"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="closeAll">取 消</el-button>
            <el-button @click="preview" :loading="loading">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 抬头打印 -->
        <el-dialog title="抬头信息" center :visible.sync="payableFormVisible" width="450px">
          <label style="display: inline-block; margin-left: 20px; margin-top: 20px">是否打印价格:</label>
          <el-radio style="margin: 0px 80px 0 50px" v-model="carryPrice" label="1">是</el-radio>
          <el-radio v-model="carryPrice" label="0">否</el-radio>
          <label style="display: inline-block; margin-left: 20px; margin-top: 40px">是否带实收:</label>
          <el-radio-group v-model="actualReceiptsRadio" style="margin-top: 20px">
            <el-radio :label="1" style="margin-left: 50px">带实收</el-radio>
            <el-radio :label="0" style="margin-left: 27px">不带实收</el-radio>
          </el-radio-group>
          <el-form :model="payableForm" ref="payableForm" style="margin-top: 20px">
            <el-form-item label="抬头信息：" :label-width="formLabelWidth">
              <el-input v-model="payableForm.NAME"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="closePayable">取 消</el-button>
            <el-button @click="submitPayable">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="修改分拣产品" center :visible.sync="editSortingCountVisible" width="80%">
          <el-form :model="editSortingCountForm" ref="editSortingCountForm" inline>
            <el-form-item label="产品名称：" :label-width="formLabelWidth">
              <span>{{ editSortingCountForm.PRODUCT_NAME }}</span>
            </el-form-item>
            <el-form-item label="单位：" :label-width="formLabelWidth">
              <span>{{ editSortingCountForm.TYPE_UNIT }}</span>
            </el-form-item>
          </el-form>
          <el-table :data="editSortingCountTable" border stripe :span-method="objectSpanMethod">
            <el-table-column label="公司名称" prop="TC_NAME" width="400"></el-table-column>
            <el-table-column label="项目点-档口" prop="DK_NAME" width="400"></el-table-column>
            <el-table-column label="客户订购数量" prop="CUSTOMER_PRODUCT_COUNT" min-width="150"></el-table-column>
            <el-table-column label="供应商送货数量" prop="CUSTOMER_NEED_COUNT" min-width="150">
              <template slot-scope="scope">
                <el-input v-model="scope.row.CUSTOMER_NEED_COUNT" @change="checkCustomerNeedCount(scope.row)"></el-input>
              </template>
            </el-table-column>
          </el-table>
          <div slot="footer" class="dialog-footer">
            <el-button @click="editSortingCountVisible = false">取 消</el-button>
            <tooltip-button :disabled="editSortingCountTableCompleted" tipContent="请将所有供应商送货数量填写正确" buttonText="确 定" :buttonLoading="loading"
              @click="submitEditSortingCount">
            </tooltip-button>
          </div>
        </el-dialog>
        <!-- 批量修改送货数量 -->
        <el-dialog title="批量修改送货数量" center :visible.sync="batchEditFormVisible" width="600px">
          <el-form :model="batchEditForm" ref="batchEditForm">
            <el-form-item label="送货数量：" :label-width="formLabelWidth">
              <el-input v-model="batchEditForm.NEED_COUNT"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="batchEditFormClose">取 消</el-button>
            <el-button @click="submitBatchEdit" :loading="loading">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  exportOrderFun,
  updateNewDetailFun,
  updatePrintOrderFun,
  updatesendCountFun,
  // supplierCusNewDetailFun,
  updateOrderFun,
  priceCountFun,
  updateSupplierPrintOrderFun,
  batchEdit,
} from 'api/sellOrder';
import { getActionFun } from 'api/login';
import bus from '@/assets/common/bus';
import http from '@/assets/common/http';
import util from '../../assets/common/util';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      fromName: ['sortingDetailsPrint', 'sellOrderPrint', 'printPreviewCustom', 'sellOrderSupplierPrintDetail', 'supplierCusOrderPrint', 'NewOrderList'],
      toName: ['sortingDetailsPrint', 'sellOrderPrint', 'printPreviewCustom', 'sellOrderSupplierPrintDetail', 'supplierCusOrderPrint'],
      loading: false,
      managername: sessionStorage.getItem('name'),
      tableData: [],
      USE_PRINT_TEMPLATE: 0,
      name: '',
      data: [
        {
          SUPPLIER_NAME: '',
          PROJECT_ADDRESS: '',
          ORDER_CODE: '',
          PROJECT_NAME: '',
          SEND_DAY: '',
          PROJECT_TELPHONE: '',
          DK_NAME: '',
        },
      ],
      printStatus: '',
      formLabelWidth: '100px',
      editFormVisible: false,
      editForm: {},
      companyID: Number(sessionStorage.getItem('tcId')),
      ORDER_ID: sessionStorage.getItem('orderId'),
      ORDER_DETAIL_ID: '',
      checkData: [],
      statusFlag: 0,
      editAllFormVisible: false,
      editAllForm: {},
      Editname: '',
      addPoint: 0,
      PAGE_ID: '1000202', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 100020201: 0, 100020202: 0 },
      currentOrderFlag: Number(sessionStorage.getItem('currentOrderFlag')),
      previewVisible: false,
      carryPrice: '0',
      actualReceiptsRadio: 0,
      nameForm: {
        companyName: '',
      },
      payableFormVisible: false,
      payableForm: {},
      payableName: '',
      rids: [],
      rcounts: [],
      purchaseDetailIDList: [],
      tcNameList: [],
      tcNameRids: [],
      tcNameRcounts: [],
      editSortingCountVisible: false,
      editSortingCountForm: {},
      PURCHASE_DETAIL_ID: '',
      // 批量修改送货数量
      multipleSelection: [],
      DETAIL_DATA: [],
      batchEditFormVisible: false,
      batchEditForm: {
        NEED_COUNT: '',
      },
      editSortingCountTable: [],
    };
  },
  computed: {
    editSortingCountTableCompleted() {
      for (const row of this.editSortingCountTable) {
        if (util.JudgmentUnit(row.TYPE_UNIT) ? !validation.数量正数0验证(row.CUSTOMER_NEED_COUNT) : !validation.数量整数正数0验证(row.CUSTOMER_NEED_COUNT)) {
          return false;
        }
      }
      return true;
    },
  },
  methods: {
    // 是否使用模板
    queryForm() {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        IS_SUPPLIER_CLIENT: 1,
        GYS_ID: sessionStorage.getItem('TEM_GYSSCID'),
      };
      http.post(params).then((result) => {
        this.USE_PRINT_TEMPLATE = result[0].USE_PRINT_TEMPLATE;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 抬头打印
    payablePrint() {
      this.payableFormVisible = true;
    },
    closePayable() {
      this.payableFormVisible = false;
      this.payableForm = {};
    },
    submitPayable() {
      if (this.payableForm.NAME) {
        this.payableName = this.payableForm.NAME;
        sessionStorage.setItem('payableName', this.payableName);
      } else {
        this.$message.show({ text: '请输入抬头信息', type: 'warning' });
        return;
      }
      this.preview();
    },
    // --------------------------------查看订单详情
    queryOrderDetailListData() {
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 44,
        ORDER_ID: Number(this.ORDER_ID),
      };
      http.post(params).then((result) => {
        this.tableData = result.length > 0 ? result[0].DETAIL : [];
        this.data = result.length > 0 ? result[0].TITLE : [];
        this.printStatus = result[0].PRINT_FLAG;
        // ---------------------------------------获取判断的companyID
        this.companyID = result[0].TITLE[0].TC_ID;
        this.addPoint = result[0].TITLE[0].ADD_POINT;
        this.checkData = result[0].OR[0].DATA;
        this.statusFlag = result[0].OR[0].RN;
        if (result[0].TITLE[0].AGENT) {
          sessionStorage.setItem('AGENT', result[0].TITLE[0].AGENT);
        } else {
          sessionStorage.setItem('AGENT', 0);
        }
        this.purchaseDetailIDList = result[0].DETAIL.map((item) => item.PURCHASE_DETAIL_ID);
        this.tcNameList = result[0].DETAIL.map((item) => JSON.stringify({ PURCHASE_DETAIL_ID: item.PURCHASE_DETAIL_ID, TC_NAME: item.TC_NAME }));
        this.isRepeated();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openPreviewDialog() {
      this.nameForm.companyName = sessionStorage.getItem('company');
      this.previewVisible = true;
    },
    preview() {
      this.$router.push({ name: 'supplierCusOrderPrint' });
      sessionStorage.setItem('sendFlag', 0);
      sessionStorage.setItem('currentOrderFlag', this.currentOrderFlag);
      sessionStorage.setItem('carryPrice', this.carryPrice);
      sessionStorage.setItem('realCountFlag', this.actualReceiptsRadio);
      sessionStorage.setItem('supplierName', this.nameForm.companyName);
    },
    previewPrint() {
      this.$router.push({ name: 'sellOrderSupplierPrintDetail' });
      sessionStorage.setItem('sendFlag', 0);
      sessionStorage.setItem('currentOrderFlag', this.currentOrderFlag);
      sessionStorage.setItem('carryPrice', this.carryPrice);
      sessionStorage.setItem('realCountFlag', this.actualReceiptsRadio);
      sessionStorage.setItem('supplierName', this.nameForm.companyName);
    },
    previewCustom() {
      this.$router.push({ name: 'printPreviewCustom' });
      sessionStorage.setItem('sendFlag', 0);
    },
    openEdit(row) {
      this.editFormVisible = true;
      this.editForm = { ...row };
      this.name = row.PRODUCT_NAME;
      this.ORDER_DETAIL_ID = row.PURCHASE_DETAIL_ID;
    },
    submitEdit() {
      const reg = /\d/;
      if (!reg.test(this.editForm.NEED_COUNT)) {
        this.$message.show({ text: '请输入数字', type: 'warning' });
        return false;
      }
      if (!util.JudgmentUnit(this.editForm.TYPE_UNIT)) {
        // 如果不是
        const beInter = this.editForm.NEED_COUNT % 1 === 0;
        if (beInter == false) {
          this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'warning' });
          return false;
        }
      }
      const params = {
        DETAIL_ID: this.ORDER_DETAIL_ID,
        NEED_COUNT: Number(this.editForm.NEED_COUNT),
      };
      if (this.currentOrderFlag === 1) {
        params.IS_SUPPLIER_CLIENT = this.currentOrderFlag;
      }
      this.loading = true;
      updateNewDetailFun(params).then((result) => {
        this.loading = false;
        this.$message.show({ text: '操作成功', type: 'success' });
        this.editFormVisible = false;
        this.updateSendCont();
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    close() {
      this.editFormVisible = false;
      this.queryOrderDetailListData();
    },
    // ----------------------------------------导出当前订单
    haveCheck() {
      this.changeStatus();
      this.export();
    },
    export() {
      const orderParams = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      if (this.currentOrderFlag === 1) {
        orderParams.IS_SUPPLIER_CLIENT = 1;
      }
      exportOrderFun(orderParams).then((result) => {
        this.$message.show({ text: '导出成功', type: 'success' });
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        this.$router.push({ name: 'NewOrderList' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // --------------------------------------改变状态
    changeStatus() {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      if (this.currentOrderFlag === 1) {
        updateSupplierPrintOrderFun(params).then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        updatePrintOrderFun(params).then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
    },
    openAllEdit(row) {
      this.editAllFormVisible = true;
      this.editAllForm = row;
      this.Editname = row.PRODUCT_NAME;
    },
    submitEditAll() {
      const reg = /\d/;
      if (!reg.test(this.editAllForm.PRODUCT_COUNT)) {
        this.$message.show({ text: '请输入数字', type: 'warning' });
        return false;
      }
      if (!util.JudgmentUnit(this.editAllForm.TYPE_UNIT)) {
        // 如果不是
        const beInter = this.editAllForm.PRODUCT_COUNT % 1 === 0;
        if (beInter == false) {
          this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'warning' });
          return false;
        }
      }
      if (!validation.价格正数0验证(this.editAllForm.REAL_PRICE)) {
        this.$message.show({ text: '请输入正确的价格', type: 'warning' });
        return false;
      }
      const params = {
        ORDER_DETAIL_ID: this.editAllForm.PURCHASE_DETAIL_ID,
        NEW_COUNT: Number(this.editAllForm.PRODUCT_COUNT),
        MODIFY_FLAG: 1,
        PRICE: this.editAllForm.REAL_PRICE,
        PRODUCT_COMMENT: this.editAllForm.PRODUCT_COMMENT,
        SUPPLIER_ID: this.data[0].SUPPLIER_ID,
        PRODUCT_CODE: this.editAllForm.PRODUCT_CODE,
      };
      if (this.currentOrderFlag === 1) {
        params.IS_SUPPLIER_CLIENT = this.currentOrderFlag;
      }
      this.loading = true;
      updateOrderFun(params).then((result) => {
        this.loading = false;
        this.$message.show({ text: '操作成功', type: 'success' });
        this.editAllFormVisible = false;
        this.queryOrderDetailListData();
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    closeAll() {
      this.editAllFormVisible = false;
      this.previewVisible = false;
    },
    countPrice() {
      // this.editAllForm.REAL_PRICE = Math.round(this.editAllForm.BUY_PRICE*(1+this.addPoint/100) *100)/100
      if (validation.价格正数验证(this.editAllForm.BUY_PRICE)) {
        const params = {
          PRICE: this.editAllForm.BUY_PRICE,
          CATALOG_ID: this.editAllForm.CATALOG_ID,
        };
        priceCountFun(params).then((result) => {
          this.editAllForm.REAL_PRICE = result[0];
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        this.$message.show({ text: '请输入正数的采购价', type: 'warning' });
        this.editAllForm.BUY_PRICE = '';
      }
    },
    updateSendCont() {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      if (this.currentOrderFlag === 1) {
        params.IS_SUPPLIER_CLIENT = this.currentOrderFlag;
      }
      updatesendCountFun(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.queryOrderDetailListData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    sendPreview() {
      this.$router.push({ name: 'sellOrderPrint' });
      sessionStorage.setItem('countFlag', 1);
    },
    shortPreview() {
      this.$router.push({ name: 'sellOrderPrint' });
      sessionStorage.setItem('countFlag', 1);
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    objectSpanMethod({
      row, column, rowIndex, columnIndex,
    }) {
      const tmpSet = new Set(this.purchaseDetailIDList);
      if (tmpSet.size != this.purchaseDetailIDList.length) {
        if (
          ['index', 'selection'].includes(column.type)
          || ['SHORT_NAME', 'BRAND', 'SPECIFICATION', 'TYPE_UNIT', 'REAL_PRICE', 'PRODUCT_COUNT', 'NEED_COUNT', 'REAL_FEE', 'PRODUCT_COMMENT', 'TC_NAME'].includes(column.property)
          || ['操作', '分拣操作'].includes(column.label)
        ) {
          if (column.label == '公司名称') {
            if (this.tcNameRids.includes(rowIndex)) {
              return {
                rowspan: this.tcNameRcounts[this.tcNameRids.indexOf(rowIndex)],
                colspan: 1,
              };
            }
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
          if (this.rids.includes(rowIndex)) {
            return {
              rowspan: this.rcounts[this.rids.indexOf(rowIndex)],
              colspan: 1,
            };
          }
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    isRepeated() {
      const tmpSet = new Set(this.purchaseDetailIDList);
      if (tmpSet.size != this.purchaseDetailIDList.length) {
        tmpSet.forEach((item1) => {
          let i = 0;
          this.purchaseDetailIDList.forEach((item2) => {
            if (item1 == item2) { i++; }
          });
          this.rids.push(this.purchaseDetailIDList.indexOf(item1));
          this.rcounts.push(i);
        });
      }
      const tmpSet2 = new Set(this.tcNameList);
      if (tmpSet2.size != this.tcNameList.length) {
        tmpSet2.forEach((item1) => {
          let i = 0;
          this.tcNameList.forEach((item2) => {
            if (item1 == item2) { i++; }
          });
          this.tcNameRids.push(this.tcNameList.indexOf(item1));
          this.tcNameRcounts.push(i);
        });
      }
    },
    indexMethod(index) {
      return [...new Set(this.purchaseDetailIDList)].indexOf(this.tableData[index].PURCHASE_DETAIL_ID) + 1;
    },
    openeditSortingCountDialog(row) {
      this.editSortingCountVisible = true;
      this.editSortingCountForm = { ...row };
      this.editSortingCountTable = [...util.deepCopy(this.tableData.filter((item) => item.PURCHASE_DETAIL_ID == row.PURCHASE_DETAIL_ID))];
    },
    submitEditSortingCount() {
      // let tmp = this.tableData.find((item) => item.ORDER_DETAIL_ID == this.editSortingCountForm.ORDER_DETAIL_ID);
      // // eslint-disable-next-line no-unused-vars
      // tmp = Object.assign(tmp, { CUSTOMER_NEED_COUNT: this.editSortingCountForm.CUSTOMER_NEED_COUNT });
      // this.calTotal();
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 43,
        PURCHASE_DETAIL_ID: this.editSortingCountForm.PURCHASE_DETAIL_ID,
        // NEED_COUNT: Number(this.tableData.find((item) => item.PURCHASE_DETAIL_ID == this.editSortingCountForm.PURCHASE_DETAIL_ID).NEED_COUNT),
        NEED_COUNT: Number(this.editSortingCountTable.reduce((total, curr) => total += Number(curr.CUSTOMER_NEED_COUNT), 0)),
        TYPE_UNIT: this.editSortingCountForm.TYPE_UNIT,
        // CUSTOMER_NEED_COUNT_ARRAY: [{ CUSTOMER_NEED_COUNT: this.editSortingCountForm.CUSTOMER_NEED_COUNT, ORDER_DETAIL_ID: this.editSortingCountForm.ORDER_DETAIL_ID }],
        CUSTOMER_NEED_COUNT_ARRAY: this.editSortingCountTable.map(({ CUSTOMER_NEED_COUNT, ORDER_DETAIL_ID }) => ({ CUSTOMER_NEED_COUNT, ORDER_DETAIL_ID })),
      };
      this.loading = true;
      http.post(params).then((result) => {
        this.loading = false;
        this.$message.show({ text: '操作成功', type: 'success' });
        this.queryOrderDetailListData();
        this.editSortingCountVisible = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    calTotal() {
      const tmpObj = {};
      this.purchaseDetailIDList.forEach((item) => {
        tmpObj[item] = { totalCount: 0, totalFee: 0 };
      });
      this.tableData.forEach((item) => {
        tmpObj[item.PURCHASE_DETAIL_ID].totalCount += Number(item.CUSTOMER_NEED_COUNT);
        tmpObj[item.PURCHASE_DETAIL_ID].totalFee += Math.round(item.CUSTOMER_NEED_COUNT * Number(item.REAL_PRICE) * 100) / 100;
      });
      this.tableData = this.tableData.map((item) => Object.assign(item, {
        NEED_COUNT: tmpObj[item.PURCHASE_DETAIL_ID].totalCount,
        REAL_FEE: tmpObj[item.PURCHASE_DETAIL_ID].totalFee,
      }));
      this.$forceUpdate();
    },
    toPrintTable({ PURCHASE_DETAIL_ID }) {
      this.$router.push({ name: 'sortingDetailsPrint' });
      sessionStorage.setItem('sortingDetails', JSON.stringify(this.tableData.filter((item) => item.PURCHASE_DETAIL_ID == PURCHASE_DETAIL_ID)));
    },
    // 批量修改送货数量
    // 多选
    handleSelectionChange(val) {
      this.DETAIL_DATA = [];
      this.multipleSelection = val;
      if (this.multipleSelection.length > 0) {
        this.multipleSelection.forEach((item) => {
          this.DETAIL_DATA.push({
            PRODUCT_CODE: item.PRODUCT_CODE,
            TYPE_UNIT: item.TYPE_UNIT,
            DETAIL_ID: Number(item.PURCHASE_DETAIL_ID),
          });
        });
      } else {
        this.DETAIL_DATA = [];
      }
    },
    batchEdit() {
      if (this.DETAIL_DATA.length == 0) {
        this.$message.show({ text: '请勾选需要修改送货数量的订单信息', type: 'warning' });
        return false;
      }
      this.batchEditFormVisible = true;
    },
    // 提交批量修改送货数量
    submitBatchEdit() {
      if (this.batchEditForm.NEED_COUNT == '') {
        this.$message.show({ text: '请填写送货数量', type: 'warning' });
        return false;
      }
      const newArr = [];
      this.DETAIL_DATA.map((item, index) => {
        newArr.push(
          Object.assign(item, { NEED_COUNT: Number(this.batchEditForm.NEED_COUNT) }),
        );
      });
      const params = {
        DETAIL_DATA: newArr,
      };
      batchEdit(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.batchEditFormVisible = false;
        this.queryOrderDetailListData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    batchEditFormClose() {
      this.batchEditFormVisible = false;
    },
    checkCustomerNeedCount(row) {
      if (util.JudgmentUnit(row.TYPE_UNIT)) {
        if (!validation.数量正数0验证(row.CUSTOMER_NEED_COUNT)) {
          this.$message.show({ text: '请输入正确的数量', type: 'warning' });
        }
      } else {
        if (!validation.数量整数正数0验证(row.CUSTOMER_NEED_COUNT)) {
          this.$message.show({ text: '请输入整数的数量', type: 'warning' });
        }
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    // 离开页面前清除订单ID
    if (!this.toName.includes(to.name)) {
      sessionStorage.removeItem('orderId');
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('orderId')) {
        that.$message.show({ text: '请从待送订单列表进入订单详情', type: 'warning' });
        that.$router.go(-1);
      } else {
        that.queryOrderDetailListData();
        that.queryBeforeFun();
        that.queryForm();
      }
    });
  },
  destroyed() {
    bus.$emit('submit', this.tableData);
  },
};
</script>
<style scoped>
.ma img {
  width: 105px;
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/supplierCusNewOrderDetail.vue